import { SEOData } from "../utils/seo";

export const pageSEOData: Record<string, SEOData> = {
  home: {
    title:
      "Dr Youssef Gam - Chirurgien Esthétique et Plastique | Tunis & Paris",
    description:
      "Dr Youssef Gam, chirurgien esthétique et plastique de référence à Tunis et Paris. Expert en rhinoplastie, augmentation mammaire, liposuccion, lifting, botox et acide hyaluronique. Consultations personnalisées à Tunis et Paris.",
    keywords: [
      "chirurgien esthétique tunisie",
      "chirurgien esthétique paris",
      "chirurgie plastique tunis",
      "chirurgie esthétique paris",
      "dr youssef gam",
      "meilleur chirurgien esthétique tunisie",
      "chirurgie esthétique tunis",
      "cabinet chirurgie esthétique tunisie",
      "chirurgien plasticien paris",
      "médecine esthétique tunis",
      "médecine esthétique paris",
      "chirurgie esthétique france tunisie",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  biographie: {
    title:
      "Biographie Dr Youssef Gam - Chirurgien Esthétique Expert | Tunis & Paris",
    description:
      "Découvrez le parcours du Dr Youssef Gam, chirurgien esthétique et plastique reconnu exerçant à Tunis et Paris. Formation, expérience internationale et spécialisations en chirurgie et médecine esthétique.",
    keywords: [
      "biographie dr youssef gam",
      "parcours chirurgien esthétique",
      "formation chirurgie plastique",
      "expert chirurgie esthétique tunisie",
      "chirurgien esthétique paris tunis",
      "cv dr gam",
      "chirurgien plasticien tunisien paris",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/biographie",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  fiches: {
    title:
      "Fiches Conseils Chirurgie Esthétique - Dr Youssef Gam | Tunis & Paris",
    description:
      "Téléchargez les fiches conseils pré et post-opératoires du Dr Youssef Gam. Informations pratiques pour votre chirurgie esthétique à Tunis ou Paris. Préparation et suivi personnalisés.",
    keywords: [
      "fiches conseils chirurgie",
      "préparation opération chirurgie esthétique",
      "post-opératoire chirurgie esthétique",
      "conseils chirurgie esthétique tunisie",
      "conseils chirurgie esthétique paris",
      "dr youssef gam fiches",
      "guide patient chirurgie plastique",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/fiches",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  visage: {
    title: "Chirurgie Esthétique du Visage à Tunis et Paris - Dr Youssef Gam",
    description:
      "Chirurgie esthétique du visage par Dr Youssef Gam à Tunis et Paris : rhinoplastie, lifting, blépharoplastie, otoplastie, génioplastie. Résultats naturels par un expert reconnu.",
    keywords: [
      "chirurgie visage tunisie",
      "chirurgie visage paris",
      "rhinoplastie tunisie",
      "rhinoplastie paris",
      "lifting visage tunisie",
      "lifting visage paris",
      "blépharoplastie tunisie",
      "blépharoplastie paris",
      "otoplastie",
      "génioplastie",
      "dr youssef gam visage",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/visage",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  seins: {
    title: "Chirurgie Esthétique des Seins à Tunis et Paris - Dr Youssef Gam",
    description:
      "Chirurgie esthétique des seins par Dr Youssef Gam à Tunis et Paris : augmentation mammaire, réduction mammaire, lifting des seins, prothèses mammaires. Expert en chirurgie mammaire.",
    keywords: [
      "augmentation mammaire tunisie",
      "augmentation mammaire paris",
      "réduction mammaire tunisie",
      "réduction mammaire paris",
      "lifting seins tunisie",
      "lifting seins paris",
      "chirurgie mammaire tunisie",
      "prothèses mammaires tunisie",
      "chirurgie mammaire paris",
      "dr youssef gam seins",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/seins",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  corps: {
    title: "Chirurgie Esthétique du Corps à Tunis et Paris - Dr Youssef Gam",
    description:
      "Chirurgie esthétique du corps par Dr Youssef Gam à Tunis et Paris : liposuccion, abdominoplastie, lifting des bras et cuisses. Remodelage corporel et résultats durables.",
    keywords: [
      "liposuccion tunisie",
      "liposuccion paris",
      "abdominoplastie tunisie",
      "abdominoplastie paris",
      "lifting bras tunisie",
      "lifting cuisses tunisie",
      "chirurgie corps tunisie",
      "chirurgie corps paris",
      "remodelage corporel tunisie",
      "remodelage corporel paris",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/corps",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  blog: {
    title:
      "Blog Chirurgie Esthétique - Dr Youssef Gam | Actualités, Conseils et Techniques",
    description:
      "Découvrez les dernières actualités et conseils en chirurgie esthétique et plastique par Dr Youssef Gam. Articles détaillés sur les techniques innovantes, conseils pré et post-opératoires, médecine esthétique à Tunis et Paris.",
    keywords: [
      "blog chirurgie esthétique",
      "actualités chirurgie plastique",
      "conseils chirurgie tunisie",
      "conseils chirurgie paris",
      "dr youssef gam blog",
      "techniques chirurgicales innovantes",
      "médecine esthétique tunisie",
      "médecine esthétique paris",
      "articles chirurgie esthétique",
      "guide patient chirurgie",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/blog",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  contact: {
    title:
      "Contact Dr Youssef Gam - Rendez-vous Chirurgie Esthétique | Tunis & Paris",
    description:
      "Prenez rendez-vous avec Dr Youssef Gam, chirurgien esthétique à Tunis et Paris. Consultations personnalisées, devis gratuit. Tunis : +216 93 733 220 | Paris : +33 6 73 27 79 48.",
    keywords: [
      "contact dr youssef gam",
      "rendez-vous chirurgien esthétique tunisie",
      "rendez-vous chirurgien esthétique paris",
      "cabinet tunis chirurgie esthétique",
      "consultation chirurgie esthétique paris",
      "consultation chirurgie esthétique tunisie",
      "devis gratuit chirurgie esthétique",
      "prendre rdv chirurgien esthétique",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/contact",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  botox: {
    title:
      "Injections Botox à Tunis et Paris - Dr Youssef Gam | Anti-Rides Expert",
    description:
      "Injections de Botox à Tunis et Paris par Dr Youssef Gam. Traitement anti-rides du front, glabelle, pattes d'oie. Résultats naturels par un chirurgien esthétique expert.",
    keywords: [
      "botox tunisie",
      "botox paris",
      "injection botox tunis",
      "injection botox paris",
      "rides visage traitement",
      "toxine botulique tunisie",
      "anti-âge tunisie",
      "anti-âge paris",
      "botox front rides",
      "dr youssef gam botox",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/botox",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  "acide-hyaluronique": {
    title:
      "Acide Hyaluronique à Tunis et Paris - Dr Youssef Gam | Injections Expert",
    description:
      "Injections d'acide hyaluronique à Tunis et Paris par Dr Youssef Gam. Augmentation des lèvres, comblement des rides, restauration des volumes du visage. Résultats naturels et immédiats.",
    keywords: [
      "acide hyaluronique tunisie",
      "acide hyaluronique paris",
      "injection lèvres tunisie",
      "injection lèvres paris",
      "comblement rides tunisie",
      "comblement rides paris",
      "rajeunissement visage tunisie",
      "filler tunisie",
      "filler paris",
      "dr gam acide hyaluronique",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/acide-hyaluronique",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  morpheus8: {
    title:
      "Morpheus 8 à Tunis et Paris - Radiofréquence Micro-aiguilles | Dr Youssef Gam",
    description:
      "Traitement Morpheus 8 à Tunis et Paris par Dr Youssef Gam. Radiofréquence fractionnée et micro-aiguilles pour raffermir et rajeunir la peau du visage et du corps. Résultats durables.",
    keywords: [
      "morpheus 8 tunisie",
      "morpheus 8 paris",
      "radiofréquence visage tunisie",
      "radiofréquence visage paris",
      "micro-aiguilles tunisie",
      "raffermir peau tunisie",
      "rajeunissement cutané tunisie",
      "rajeunissement cutané paris",
      "microneedling tunisie",
      "dr youssef gam morpheus8",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/morpheus8",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  filler: {
    title:
      "Injections de Comblement Visage et Corps à Tunis et Paris | Dr Youssef Gam",
    description:
      "Injections de comblement visage et corps à Tunis et Paris par Dr Youssef Gam. Restauration des volumes, redéfinition des contours du visage et du corps. Résultats naturels.",
    keywords: [
      "filler tunisie",
      "filler paris",
      "comblement visage tunisie",
      "comblement visage paris",
      "injection corps tunisie",
      "augmentation fessier tunisie",
      "volumes visage tunisie",
      "volumes visage paris",
      "dr youssef gam filler",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/filler",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  sculptra: {
    title:
      "Sculptra à Tunis et Paris - Bio-stimulation Collagène | Dr Youssef Gam",
    description:
      "Traitement Sculptra à Tunis et Paris par Dr Youssef Gam. Bio-stimulation du collagène pour restaurer les volumes du visage et du corps. Rajeunissement naturel et durable.",
    keywords: [
      "sculptra tunisie",
      "sculptra paris",
      "bio-stimulation collagène tunisie",
      "bio-stimulation collagène paris",
      "acide poly-l-lactique",
      "volumes visage tunisie",
      "rajeunissement naturel tunisie",
      "rajeunissement naturel paris",
      "dr youssef gam sculptra",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/sculptra",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  threadLift: {
    title:
      "Fils Tenseurs à Tunis et Paris - Lifting Sans Chirurgie | Dr Youssef Gam",
    description:
      "Pose de fils tenseurs à Tunis et Paris par Dr Youssef Gam. Lifting sans chirurgie du visage et du cou. Résultats immédiats et naturels, récupération rapide.",
    keywords: [
      "fils tenseurs tunisie",
      "fils tenseurs paris",
      "lifting sans chirurgie tunisie",
      "lifting sans chirurgie paris",
      "rajeunissement visage tunisie",
      "fils résorbables tunisie",
      "lifting fils tunisie",
      "lifting fils paris",
      "dr youssef gam fils tenseurs",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/threadLift",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  hairTransplant: {
    title: "Greffe de Cheveux à Tunis et Paris - FUE | Dr Youssef Gam",
    description:
      "Greffe de cheveux FUE à Tunis et Paris par Dr Youssef Gam. Transplantation capillaire moderne pour résultats naturels et définitifs. Expert en traitement de la calvitie.",
    keywords: [
      "greffe cheveux tunisie",
      "greffe cheveux paris",
      "transplantation capillaire tunisie",
      "transplantation capillaire paris",
      "technique FUE tunisie",
      "calvitie tunisie",
      "calvitie paris",
      "implants capillaires tunisie",
      "dr youssef gam greffe cheveux",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/hairTransplant",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  hydrafacial: {
    title:
      "Hydrafacial à Tunis et Paris - Soin Visage Haute Technologie | Dr Youssef Gam",
    description:
      "Soin Hydrafacial à Tunis et Paris par Dr Youssef Gam. Nettoyage profond, exfoliation, hydratation intense. Peau éclatante et purifiée dès la première séance.",
    keywords: [
      "hydrafacial tunisie",
      "hydrafacial paris",
      "soin visage tunisie",
      "soin visage paris",
      "nettoyage peau profond tunisie",
      "hydratation visage tunisie",
      "peau éclatante tunisie",
      "peau éclatante paris",
      "dr youssef gam hydrafacial",
    ],
    canonicalUrl: "https://www.dryoussefgam.com/hydrafacial",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },

  login: {
    title: "Connexion - Espace Professionnel Dr Youssef Gam",
    description:
      "Espace de connexion réservé aux professionnels et collaborateurs du Dr Youssef Gam.",
    keywords: ["connexion", "espace professionnel", "dr youssef gam"],
    canonicalUrl: "https://www.dryoussefgam.com/login",
    ogImage: "https://www.dryoussefgam.com/logo-black.png",
  },
};
